import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

interface Shortcut {
  // Lowercase key (KeyboardEvent.key.toLowerCase()) — например '/', 'l', 'f', 'k'.
  key: string
  path: string
}

const ROUTE_SHORTCUTS: Shortcut[] = [
  { key: '/', path: '/' },
  { key: 'l', path: '/library' },
  { key: 's', path: '/subscriptions' },
  { key: 'f', path: '/settings/feed' },
  { key: 'k', path: '/settings/security' },
  { key: 't', path: '/settings/tokens' },
  { key: 'c', path: '/settings/cookies' },
]

// Возвращает true если фокус сейчас в поле ввода — тогда шорткаты не трогаем,
// иначе невозможно набирать '/' или буквы в форме.
function isTypingInForm(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  const tag = target.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (target.isContentEditable) return true
  return false
}

export function useKeyboardShortcuts(): void {
  const navigate = useNavigate()
  useEffect(() => {
    function handler(event: KeyboardEvent) {
      if (event.metaKey || event.ctrlKey || event.altKey) return
      if (isTypingInForm(event.target)) return
      const key = event.key.toLowerCase()
      const shortcut = ROUTE_SHORTCUTS.find((s) => s.key === key)
      if (!shortcut) return
      event.preventDefault()
      void navigate(shortcut.path)
    }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [navigate])
}
